(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creator-video-carousel"] && !Shopify.designMode) return;
  try {
    
/**
 * Creator video carousel.
 * - Autoplays/pauses videos with IntersectionObserver (muted, inline, looping).
 * - Arrow + dot navigation over a native scroll-snap track.
 * - Hides controls when the track does not overflow (desktop, all cards visible).
 * Re-runs safely on Shopify theme editor section reloads.
 */
(function () {
  function initCreatorVideos(root) {
    if (!root || root.dataset.tavaCvReady === 'true') return;
    root.dataset.tavaCvReady = 'true';

    var track = root.querySelector('[data-tava-cv-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-tava-cv-slide]'));
    var prevBtn = root.querySelector('[data-tava-cv-prev]');
    var nextBtn = root.querySelector('[data-tava-cv-next]');
    var dotsWrap = root.querySelector('[data-tava-cv-dots]');
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-tava-cv-dot]')) : [];
    var shell = track.parentElement;

    // Force muted/inline playback attributes so JS-triggered play() is allowed
    var videos = Array.prototype.slice.call(root.querySelectorAll('video'));
    videos.forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.removeAttribute('controls');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('aria-hidden', 'true');
      video.tabIndex = -1;
    });

    // Play videos only while visible; pause off-screen ones
    if ('IntersectionObserver' in window && videos.length) {
      var playObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.45) {
              var playPromise = video.play();
              if (playPromise && playPromise.catch) playPromise.catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: [0, 0.45] }
      );
      videos.forEach(function (video) { playObserver.observe(video); });
    }

    // Scroll the requested slide into the horizontal center of the track
    function goToSlide(index) {
      var slide = slides[index];
      if (!slide) return;
      slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    // Pick whichever slide is closest to the track midpoint
    function activeIndex() {
      var trackMid = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (slide, i) {
        var slideMid = slide.offsetLeft + slide.offsetWidth / 2;
        var dist = Math.abs(slideMid - trackMid);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    // Sync dots + arrow disabled state, hide controls when nothing scrolls
    function syncUi() {
      var overflows = track.scrollWidth > track.clientWidth + 4;
      if (shell) shell.classList.toggle('is-static', !overflows);
      if (dotsWrap) dotsWrap.classList.toggle('is-static', !overflows);

      var idx = activeIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
        dot.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll - 4;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToSlide(Math.max(0, activeIndex() - 1));
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToSlide(Math.min(slides.length - 1, activeIndex() + 1));
      });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goToSlide(i);
      });
    });

    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(syncUi, 80);
    }, { passive: true });
    window.addEventListener('resize', syncUi);

    syncUi();
  }

  function initAll() {
    document.querySelectorAll('[data-tava-creator-videos]').forEach(initCreatorVideos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init when the section is (re)loaded
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-tava-creator-videos]');
    if (root) {
      root.dataset.tavaCvReady = 'false';
      initCreatorVideos(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
